<!-- Notifications -->
<div class="page-header">
  <div class="header-content">
    <div class="header-main">
      <div class="header-icon">
        <i class="fas fa-bell"></i>
      </div>
      <div class="header-text">
        <h1 class="page-title">Notifications</h1>
        <p class="page-description">Stay updated with your latest alerts and messages</p>
      </div>
    </div>
    <div class="header-actions">
      <div class="stats-badge">
        <i class="fas fa-envelope me-1"></i>
        {{ notifications?.length || 0 }} Notifications
      </div>
    </div>
  </div>
</div>

<!-- Notifications List -->
<div class="data-panel">
  <div class="panel-header">
    <div class="panel-title">
      <div class="title-icon">
        <i class="fas fa-list-alt"></i>
      </div>
      <div class="title-content">
        <div class="title-text">All Notifications</div>
        <div class="title-subtitle">Click a notification to view details</div>
      </div>
    </div>
  </div>

  <div class="panel-body">
    @for (item of notifications; track $index) {
    <div class="notification-item" (click)="open(item.id)" style="display: flex; align-items: flex-start; gap: 14px; padding: 16px 20px; border-bottom: 1px solid var(--table-border); cursor: pointer; transition: background-color var(--transition);"
         onmouseover="this.style.backgroundColor='var(--table-row-hover)'" onmouseout="this.style.backgroundColor='transparent'">
      <div style="width: 36px; height: 36px; border-radius: var(--radius-md); background: var(--accent-subtle); color: var(--accent); display: flex; align-items: center; justify-content: center; font-size: 14px; flex-shrink: 0;">
        <i class="fas fa-bell"></i>
      </div>
      <div style="flex: 1; min-width: 0;">
        <div style="font-size: 14px; font-weight: 600; color: var(--text-primary); margin-bottom: 4px;">{{ item?.data?.title }}</div>
        <div style="font-size: 13px; color: var(--text-secondary); line-height: 1.5;">{{ item?.data?.details }}.</div>
      </div>
      <div style="flex-shrink: 0; margin-left: auto;">
        <i class="fas fa-chevron-right" style="color: var(--text-tertiary); font-size: 12px;"></i>
      </div>
    </div>
    }@empty {
    <div class="empty-state">
      <div class="empty-icon">
        <i class="fas fa-bell-slash fa-3x"></i>
      </div>
      <div class="empty-content">
        <h5>No Notifications</h5>
        <p>You're all caught up! New notifications will appear here.</p>
      </div>
    </div>
    }
  </div>
</div>
